<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  import { toggleTheme, theme } from '../models';
  import { ThemeModes } from '../types';
</script>

<button on:click="{toggleTheme}">
  <Icon name="{$theme === ThemeModes.Dark ? 'moon' : 'theme'}" classes="hover:text-default-500 transition-colors" />
</button>
